export function pearsonLiveModuleCount(pearsonModules, { isUcatExam = false } = {}) {
  const n = Array.isArray(pearsonModules) ? pearsonModules.length : 0;
  if (n > 0) return n;
  return isUcatExam ? 4 : 3;
}
